import { ChangeDetectorRef, Component, inject, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { AddressFormComponent } from "./components/address-form/address-form.component";
import { ContactDetailsFormComponent } from "./components/contact-details-form/contact-details-form.component";
import { AboutYouFormComponent } from "./components/about-you-form/about-you-form.component";
import countries from "../../../../assets/countries.json";
import { ApiService } from "../../../../../../shared/src";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { TranslateModule } from "@ngx-translate/core";
import { MatIconModule } from "@angular/material/icon";
import { SnackbarService } from "../../../../../../shared/src/lib/services/snackbar.service";
import { LoaderService } from "../../../../../../shared/src/lib/services/loader.service";
import { MatSlideToggle, MatSlideToggleChange } from "@angular/material/slide-toggle";
import { Observable } from "rxjs";
import { AsyncPipe } from "@angular/common";

@Component({
    selector: "app-my-account",
    imports: [
        MatButtonModule,
        AddressFormComponent,
        ContactDetailsFormComponent,
        AboutYouFormComponent,
        MatProgressBarModule,
        TranslateModule,
        MatIconModule,
        MatSlideToggle,
        AsyncPipe,
    ],
    templateUrl: "./my-account.component.html",
    styleUrl: "./my-account.component.scss"
})
export class MyAccountComponent implements OnInit {
  loader = inject(LoaderService);
  editFlag = false;
  accountBackup: any = null;
  myAccount: any = null;
  apiService = inject(ApiService);
  snackbar = inject(SnackbarService);
  cdr = inject(ChangeDetectorRef);
  formValidity: any = {};
  loading$!: Observable<boolean>;

  constructor() {}

  get userName() {
    const user = this.apiService.getUserToken();
    return user?.user?.NAME;
  }

  ngOnInit() {
    this.loading$ = this.loader.isLoading("/api/users/getById");
    this.getUserAccount();
  }

  getUserAccount() {
    const app = this.apiService.getUserToken();
    this.apiService.fetchUserAccount({ id: app?.user?.ID }).subscribe((response: any) => {
      if (response.status === "ok") {
        this.myAccount = response?.result[0];
        this.accountBackup = response?.result[0];
      }
    });
  }

  updateAccount(update: any) {
    this.myAccount = { ...this.myAccount, ...update };
    this.cdr.detectChanges();
  }

  handle2faToggle(event: MatSlideToggleChange) {
    this.myAccount = { ...this.myAccount, IS_2FA_ENABLED: event.checked };
    this.handleSubmit();
  }

  handleSubmit() {
    const user = this.apiService.getUserToken();
    this.apiService.updateUserAccount({ ...this.myAccount, USER_ID: user?.user?.ID }).subscribe((response: any) => {
      // console.log(response);
      if (response?.status === "ok") {
        this.snackbar.openSnackbar({
          message: "Account Information Updated Successfully!",
        });
        this.toggleEdit(false);
        this.getUserAccount();
      } else {
        this.snackbar.openSnackbar({
          message: JSON.stringify(response?.result),
        });
      }
    });
  }

  handleFlag(flag: boolean) {
    this.toggleEdit(flag);
    if (!flag) {
      this.myAccount = this.accountBackup;
    }
  }

  toggleEdit(state: boolean) {
    this.editFlag = state;
  }

  getCountry(code: string) {
    const country = countries.find((x) => x.code === code);
    return country?.name;
  }

  get isFormValid() {
    return !Object.values(this.formValidity).includes(false);
  }

  setFormValidity($event: any) {
    this.formValidity[$event.form] = $event?.status;
  }
}
